<template>
    <div v-bind:style="{paddingTop: '50px'}" v-if="this.$store.state.websiteDataLoaded">
        <controls v-model="current" :total="countries.length"/>
        <component
                height="350px"
                v-model="current"
                ref="slider"
                :is="enabled ? types[0] : 'div'"
                class="grid"
                :interval="5000"
                :per-page="1"
                :per-page-custom="[[1025, 3], [1366, 4]]"
                :control-btn="false"
                :pagination-enabled="false"
                :indicators="false">
            <component :is="enabled ? types[1] : 'div'" v-for="(c, i) in countries" :key="i">
                <router-link :to="`/citizenship/${ getCitizenshipBySlug(c).slug }`" class="item">
                    <div v-bind:style="{
              backgroundImage: 'url(\'https://api.my2ndpassport.com/storage/app/media/'+ getCitizenshipBySlug(c).image_preview + '\')',
              backgroundPosition: 'center',
              backgroundSize: 'cover'
           }" class="wrapper">
                        <!-- <img :src="'https://api.my2ndpassport.com/storage/app/media/'+ getCitizenshipBySlug(c).image_preview ">-->
                    </div>
                    <div class="label">{{ getCitizenshipBySlug(c).name }}</div>
                </router-link>
            </component>
        </component>
    </div>
</template>

<script>
    import Controls from './slider-controls';
    import { mapGetters } from 'vuex';

    export default {
        components: { Controls },
        props: {
            type: { type: String, default: 'slider' },
        },
        data: () => ({
            mobile: screen.width < 768,
            current: 0,
            countries: [
                'antigua-and-barbuda-citizenship-investment-programme',
                'dominica',
                'grenada',
                'st-kitts-nevis',
                'st-lucia',
                'vanuatu',
                'malta',
                'cyprus',
            ],
        }),
        computed: {
            enabled() {
                return this.type === 'carousel' || this.mobile;
            },
            types() {
                if (this.type === 'slider')
                    return ['slider', 'slider-item'];
                return ['carousel', 'slide'];
            },
            ...mapGetters(['getCitizenshipBySlug']),
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/mixins.scss';

    .label {
        position: relative;
        color: #484848;
        font-size: 24px;
        margin-top: 20px;
        transition: all 0.3s;

        &:after {
            content: '→';
            position: absolute;
            top: calc(100% + 10px);
            left: 0;
            right: 0;
            text-align: center;
            font-size: 40px;
            transform: scaleX(0);
            transition: all 0.3s;
            transform-origin: left;
            color: #fff;
            transition-delay: 0.2s;
        }
    }

    .grid {
        @include desktop {
            display: grid;
            grid-gap: 30px;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            justify-content: space-between;
        }
    }

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;


        &:hover {
            .label {
                top: 40%;
                transform: translateY(-220px);
                color: #fff;
                font-size: 24px;
                font-weight: 700;
                text-align: center;

                &:after {
                    transform: scaleX(1);
                }
            }

            .wrapper:after {
                opacity: 0.8;
            }
        }

        img {
            display: block;
        }

        .wrapper {
            position: relative;
            width: 100%;
            height: 300px;
            border-radius: 6px;

            &:after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-image: linear-gradient(42deg, #97ca54 0%, #83ca54 100%);
                opacity: 0;
                border-radius: 6px;
                transition: all 0.3s;
            }
        }
    }
</style>